"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _native = _interopRequireDefault(require("styled-components/native"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _ThemeProvider = _interopRequireWildcard(require("./ThemeProvider"));

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  font-size: ", ";\n\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  min-width: ", ";\n  align-items: center;\n  justify-content: center;\n  padding: ", ";\n  margin: ", ";\n  border-width: ", ";\n  border-color: ", ";\n  border-style: solid;\n  border-radius: ", ";\n\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  min-width: ", ";\n  align-items: center;\n  justify-content: center;\n  padding: ", ";\n  margin: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  font-size: ", ";\n  margin: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex-direction: row;\n  align-items: center;\n  padding: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SvgArrowRight = function SvgArrowRight(props) {
  return _react.default.createElement("svg", (0, _extends2.default)({
    width: "5",
    height: "8",
    viewBox: "0 0 5 8"
  }, props), _react.default.createElement("path", {
    d: "M.147.854L3.293 4 .147 7.147a.5.5 0 0 0 .707.707l3.5-3.5a.498.498 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.707.708z",
    fill: props.muitheme.arrowColor,
    fillRule: "evenodd"
  }));
};

var SvgArrowLeft = function SvgArrowLeft(props) {
  return _react.default.createElement("svg", (0, _extends2.default)({
    width: "5",
    height: "8",
    viewBox: "0 0 5 8"
  }, props), _react.default.createElement("path", {
    d: "M4.853 7.146L1.707 4 4.853.853a.5.5 0 0 0-.707-.707l-3.5 3.5a.498.498 0 0 0 0 .708l3.5 3.5a.5.5 0 0 0 .707-.708z",
    fill: props.muitheme.arrowColor,
    fillRule: "evenodd"
  }));
};

var Container = _native.default.View(_templateObject(), function (props) {
  return props.muitheme.padding;
});

var Label = _native.default.Text(_templateObject2(), function (props) {
  return props.muitheme.labelColor;
}, function (props) {
  return props.muitheme.fontSize;
}, function (props) {
  return props.muitheme.labelMargin;
});

var ArrowButton = _native.default.TouchableOpacity(_templateObject3(), function (props) {
  return props.muitheme.buttonMinWidth;
}, function (props) {
  return props.muitheme.buttonPadding;
}, function (props) {
  return props.muitheme.buttonMargin;
});

var PageButton = _native.default.TouchableOpacity(_templateObject4(), function (props) {
  return props.muitheme.buttonMinWidth;
}, function (props) {
  return props.muitheme.buttonPadding;
}, function (props) {
  return props.muitheme.buttonMargin;
}, function (props) {
  return props.muitheme.buttonBorderWidth;
}, function (props) {
  return props.muitheme.buttonBorderColor;
}, function (props) {
  return props.muitheme.buttonBorderRadius;
}, function (props) {
  return props.selected && "border-color: " + props.muitheme.buttonSelectedBorderColor + ";";
});

var PageText = _native.default.Text(_templateObject5(), function (props) {
  return props.muitheme.buttonColor;
}, function (props) {
  return props.muitheme.fontSize;
}, function (props) {
  return props.selected && "color: " + props.muitheme.buttonSelectedColor + ";";
});

var Pagination =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(Pagination, _Component);

  function Pagination(_props) {
    var _this;

    _this = _Component.call(this, _props) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getPages", function () {
      var currentPage = _this.state.currentPage;
      var displayCount = _this.props.maxDisplay && _this.props.maxDisplay < _this.props.numPages ? _this.props.maxDisplay : _this.props.numPages;
      var start = 1;
      var middle = Math.floor(displayCount / 2);

      if (currentPage - middle >= 1) {
        start = currentPage - middle;

        if (start + displayCount - 1 > _this.props.numPages) {
          start = _this.props.numPages - displayCount + 1;
        }
      }

      var pagesArray = [];

      for (var i = start; i < start + displayCount; i++) {
        pagesArray.push(i);
      }

      return pagesArray;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getPaginationTheme", (0, _memoizeOne.default)(function (props, context) {
      return (0, _ThemeProvider.getTheme)('Pagination', props, context);
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onSelectPage", function (page) {
      _this.props.onSelectPage && _this.props.onSelectPage(page);

      _this.setState({
        currentPage: page
      });
    });
    _this.state = {
      currentPage: _props.defaultPage && _props.defaultPage > 0 && _props.defaultPage <= _props.numPages ? _props.defaultPage : 1
    };
    return _this;
  }

  var _proto = Pagination.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var muitheme = this.getPaginationTheme(this.props, this.context);
    var pages = this.getPages();
    var first = pages.length ? pages[0] : 0;
    var last = pages.length ? pages[pages.length - 1] : this.props.numPages;
    return _react.default.createElement(Container, {
      muitheme: muitheme
    }, this.props.label && _react.default.createElement(Label, {
      muitheme: muitheme
    }, this.props.label), first > 1 && _react.default.createElement(ArrowButton, {
      muitheme: muitheme,
      onPress: function onPress() {
        return _this2.onSelectPage(first - 1);
      }
    }, _react.default.createElement(SvgArrowLeft, {
      muitheme: muitheme
    })), pages.map(function (page) {
      return _react.default.createElement(PageButton, {
        muitheme: muitheme,
        selected: _this2.state.currentPage === page,
        onPress: function onPress() {
          return _this2.onSelectPage(page);
        },
        key: "page-" + page
      }, _react.default.createElement(PageText, {
        muitheme: muitheme,
        selected: _this2.state.currentPage === page
      }, page));
    }), last < this.props.numPages && _react.default.createElement(ArrowButton, {
      muitheme: muitheme,
      onPress: function onPress() {
        return _this2.onSelectPage(last + 1);
      }
    }, _react.default.createElement(SvgArrowRight, {
      muitheme: muitheme
    })));
  };

  return Pagination;
}(_react.Component);

exports.default = Pagination;
(0, _defineProperty2.default)(Pagination, "contextType", _ThemeProvider.default);